<template>
  <div>
    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="$router.push('/users')"
    >
      <feather-icon
        size="16"
        icon="UnlockIcon"
        class="mr-50"
      />
      <span>Access & Security</span>
    </b-dropdown-item>
    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="$router.push({name: 'settings-users'})"
    >
      <feather-icon
        size="16"
        icon="DatabaseIcon"
        class="mr-50"
      />
      <span>Data Source</span>
    </b-dropdown-item>
    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="$router.push({name: 'settings-labelling'})"
    >
      <feather-icon
        size="16"
        icon="TagIcon"
        class="mr-50"
      />
      <span>Campaign Labelling</span>
    </b-dropdown-item>
    <b-dropdown-item
      link-class="d-flex align-items-center"
      disabled
      @click="$router.push({name: 'global-onboardingForm'})"
    >
      <feather-icon
        size="16"
        icon="InfoIcon"
        class="mr-50"
      />
      <span>Onboarding</span>
    </b-dropdown-item>
    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="$router.push({name: 'trust-finance-invoice', params: {pageType: 'invoices'}})"
    >
      <feather-icon
        size="16"
        icon="FileTextIcon"
        class="mr-50"
      />
      <span>Invoices</span>
    </b-dropdown-item>
  </div>
</template>

<script>
import {
  BDropdownItem,
} from 'bootstrap-vue'
import { initialAbility } from '@/libs/acl/config'
import { Auth, Hub } from 'aws-amplify'

export default {
  components: {
    BDropdownItem,
  },
  methods: {
    async logout() {
      try {
        await Auth.signOut()

        this.$store.commit('auth/updateIdToken', undefined)
        this.$store.commit('auth/updateState', undefined)
        this.$store.commit('auth/updateUserDataKey', undefined)
        
        // Reset ability
        this.$ability.update(initialAbility)
        
        Hub.dispatch('UI Auth', {
          event: 'AuthStateChange',
          message: 'signedout',
        })
        
        try {
          await this.$store.dispatch('resetAllStore')
          localStorage.clear()
          await this.$router.push({ name: 'auth-login' })
        } catch (e) {
          console.log(e)
          await this.$router.push({ name: 'auth-login' })
        }
      } catch (error) {
        console.log('error signing out: ', error)
      }
    },
  },
}
</script> 